import React from 'react';
import SVGIcon from '../components/SVGIcon';
import templateIcon from '../icons/prefilled/16x16/template.svg';
import * as styles from './TemplateIcon.module.scss';

const TemplateIcon = () => {
  return (
    <div className={styles.icon}>
      <SVGIcon>{templateIcon}</SVGIcon>
    </div>
  );
};

export default TemplateIcon;
